import React, { useEffect, useRef } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { trackPageView } from '@core/analytics';

const AnalyticsRouteTrackerBase: React.FC<RouteComponentProps> = ({ location }) => {
  const previousHref = useRef<string | undefined>(undefined);

  useEffect(() => {
    const referrer = previousHref.current;
    const timer = window.setTimeout(() => {
      trackPageView({ pathname: location.pathname, search: location.search }, referrer);
      previousHref.current = `${window.location.origin}${location.pathname}${location.search || ''}`;
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
};

export const AnalyticsRouteTracker = withRouter(AnalyticsRouteTrackerBase);

